import { Component, OnInit, Input, Output, EventEmitter, Directive } from '@angular/core';
import notify from 'devextreme/ui/notify';
import { LanguageService } from '../../../../shared/services/language.service';
import { UserService } from '../../../../shared/services/user.service';
import { ProductionStatusService } from '../../_api/services/production-status-service';


let self: ProductionStatusReportComponent = null

@Component({
  selector: 'app-production-status-report',
  templateUrl: './production-status-report.component.html',
  styleUrls: ['./production-status-report.component.css']
})
export class ProductionStatusReportComponent implements OnInit {

  private _showPublicly = false;
  @Input() set showPublicly(v: boolean) {
    this._showPublicly = v;
  }
  get showPublicly() {
    return this._showPublicly;
  }
  @Output() refreshCallbackChanged = new EventEmitter<any>();
  @Input() showTitle: boolean;
  columnCount: number;
  rowHeight: string;
  report: any;
  reportData: any;

  private _reportId: number;
  @Input() set reportId(n: number) {
    this._reportId = n;
    //maybe do the refresh...
  }

  get reportId(): number {
    return this._reportId;
  }


  inspect(data) {
    
  }

  constructor(public ls: LanguageService, public us: UserService, public ds: ProductionStatusService) {
    self = this;
    this.showTitle = false;
    this.columnCount = 0;
    this.rowHeight = "2:1";
    this.report = null;
    this.reportData = null;

  }

  ngOnInit() {
    this.refresh();
  }


  refresh() {
    self.columnCount = 0;
    self.report = null;
    self.ds.getProductionStatusReport(self._reportId).toPromise().then((data) => {
      self.columnCount = data.Report.ColumnCount;
      self.report = data.Report;
      self.reportData = data.Data;
    }).catch((error) => {
      self.columnCount = 0;
      self.report = null;
      notify(error, "error", 1000);
    }).finally(() => {
      if (self._showPublicly) {
        self.refreshCallbackChanged.emit({
          sleepTimeInMilliSeconds: self.report !== null ? self.report.RefreshIntervalInMinutes * 60000 : 15 * 60000,//if the data retrieval failed wait 15 minutes before trying again
          refreshFunction: self.refresh
        });
      }
    });
  }
}

@Directive()
export class ReportElement {

  @Input() reportReportElement: any;
  @Input() data: any

  constructor() {
    this.reportReportElement = null;
    this.data = null;
  }
}
